
import Vue from 'vue'

const locales = {keys(){return []}}
global['____EBFC3F5____'] = true;
delete global['____EBFC3F5____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"营山县政务公开一码通"},"uniIdRouter":{}};
global.__uniConfig.compilerVersion = '5.14';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__EBFC3F5';
global.__uniConfig.appName = '营山县政务公开一码通';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"amap":{"key":"131d163bcf6f2d56065ef85ef365409f","securityJsCode":"2c8c69626ae8e608ab5811abc3a0def7","serviceHost":""}}};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = "131d163bcf6f2d56065ef85ef365409f";
global.__uniConfig.aMapSecurityJsCode = "2c8c69626ae8e608ab5811abc3a0def7";
global.__uniConfig.aMapServiceHost = "";
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Notice-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Notice/list"+'.vue')), 'pages-Notice-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-yearBook-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/yearBook/list"+'.vue')), 'pages-yearBook-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-yearBook-yeardetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/yearBook/yeardetail"+'.vue')), 'pages-yearBook-yeardetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pdfView-pdfView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/pdfView/pdfView"+'.vue')), 'pages-pdfView-pdfView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-life-life', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/life/life"+'.vue')), 'pages-life-life'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-web-view-web-view', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/web-view/web-view"+'.vue')), 'pages-web-view-web-view'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-company-company', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/company/company"+'.vue')), 'pages-company-company'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Media-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Media/index"+'.vue')), 'pages-Media-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Media-components-WeChat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Media/components/WeChat"+'.vue')), 'pages-Media-components-WeChat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Media-components-MicroBlog', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Media/components/MicroBlog"+'.vue')), 'pages-Media-components-MicroBlog'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Media-components-Tiktok', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Media/components/Tiktok"+'.vue')), 'pages-Media-components-Tiktok'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-Notice-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/Notice/detail"+'.vue')), 'pages-Notice-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-map-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/home/ying_shan_yi_ma_tong/ysymt-mobile/pages/map/index"+'.vue')), 'pages-map-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"营山县政务公开一码通","navigationStyle":"custom"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/Notice/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"政府公报","navigationStyle":"custom"})
      },
      [
        createElement('pages-Notice-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Notice-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Notice/list',
  windowTop:0
}
},
{
path: '/pages/yearBook/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"县志年鉴","navigationStyle":"custom"})
      },
      [
        createElement('pages-yearBook-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-yearBook-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/yearBook/list',
  windowTop:0
}
},
{
path: '/pages/yearBook/yeardetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"县志年鉴详情","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-yearBook-yeardetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-yearBook-yeardetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/yearBook/yeardetail',
  windowTop:0
}
},
{
path: '/pages/pdfView/pdfView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预览文件","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-pdfView-pdfView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pdfView-pdfView',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pdfView/pdfView',
  windowTop:0
}
},
{
path: '/pages/life/life',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人全生命周期一本通","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-life-life', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-life-life',
  isNVue:false,maxWidth:0,
  pagePath:'pages/life/life',
  windowTop:0
}
},
{
path: '/pages/web-view/web-view',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-web-view-web-view', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-web-view-web-view',
  isNVue:false,maxWidth:0,
  pagePath:'pages/web-view/web-view',
  windowTop:0
}
},
{
path: '/pages/company/company',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"企业全生命周期一本通","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-company-company', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-company-company',
  isNVue:false,maxWidth:0,
  pagePath:'pages/company/company',
  windowTop:0
}
},
{
path: '/pages/Media/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新媒体矩阵","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-Media-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Media-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Media/index',
  windowTop:0
}
},
{
path: '/pages/Media/components/WeChat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-Media-components-WeChat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Media-components-WeChat',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Media/components/WeChat',
  windowTop:0
}
},
{
path: '/pages/Media/components/MicroBlog',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-Media-components-MicroBlog', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Media-components-MicroBlog',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Media/components/MicroBlog',
  windowTop:0
}
},
{
path: '/pages/Media/components/Tiktok',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-Media-components-Tiktok', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Media-components-Tiktok',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Media/components/Tiktok',
  windowTop:0
}
},
{
path: '/pages/Notice/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"政府公报详情","enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-Notice-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-Notice-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/Notice/detail',
  windowTop:0
}
},
{
path: '/pages/map/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"政务地图","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-map-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-map-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/map/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
